// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"ModalWindow__wrapper","content":"ModalWindow__content","modalLg":"ModalWindow__modal-lg","modal":"ModalWindow__modal","modalMd":"ModalWindow__modal-md"};